/* eslint dom-in-jsx/no-jquery-in-jsx: 0 */

import React, { Component, createRef } from 'react';
import HashTree from './HashTree.jsx';
import HashPropertyForm from './HashPropertyForm.jsx';
import HashElementForm from './HashElementForm.jsx';
import JsonPreview from '../JsonPreview.jsx';
import EventEmitter from '../../util/eventEmitter.js';

export default class HashBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      propertyErrors: props.errors,
      property: this.normalizeProperty(props.property),
      children: props.property.hash_definition || [],
      visible: false,
      element: false,
      openModal: false,
      enabled: props.enabled,
    };

    this.treeRef = createRef();
    this.updateDefinitionState = this.updateDefinitionState.bind(this);
    this.updateErrorState = this.updateErrorState.bind(this);
    this.openModalPreview = () => this.setState({ openModal: true });
    this.disableSidePanel = () => this.setState({ enabled: false });
    this.enableSidePanel = () => this.setState({ enabled: true });

    this.listen();
  }

  listen() {
    EventEmitter.on('enableHashBuilderSidePanel', this.enableSidePanel);
    EventEmitter.on('disableHashBuilderSidePanel', this.disableSidePanel);
    EventEmitter.on('openHashBuilderPreview', this.openModalPreview);
    EventEmitter.on('rebuildDefinition', this.updateDefinitionState);
    EventEmitter.on('setDefinitionErrors', this.updateErrorState);
  }

  componentWillUnmount() {
    EventEmitter.off('enableHashBuilderSidePanel', this.enableSidePanel);
    EventEmitter.off('disableHashBuilderSidePanel', this.disableSidePanel);
    EventEmitter.off('openHashBuilderPreview', this.openModalPreview);
    EventEmitter.off('rebuildDefinition', this.updateDefinitionState);
    EventEmitter.off('setDefinitionErrors', this.updateErrorState);
  }

  normalizeProperty(property) {
    ['name', 'template_name', 'description'].map((i) => {
      if (property[i] === null) {
        property[i] = '';
      }
    });

    return property;
  }

  updateErrorState(errors) {
    this.setState({ propertyErrors: errors });
  }

  updateDefinitionState(children) {
    this.setState({ children: children });
  }

  updateProperty(obj) {
    this.setState({ property: obj });
  }

  updateElement(element) {
    this.setState({ element: element });
    this.treeRef.current.updateByName(element);
  }

  displayName() {
    if (this.state.property.name === '') {
      return 'Please Define';
    }
    return `${this.state.property.name} <${this.state.property.template_name}>`;
  }

  togglePropertyPanel() {
    let visible = this.state.visible === 'property' ? false : 'property';

    if (visible === 'property') {
      this.treeRef.current.inactiveAll();
    }
    this.setState({ visible: visible });
  }

  updateChildren(children, callback) {
    this.setState({ children: children }, callback);
    this.updateCurrentElementChildren({ children: children });
  }

  updateCurrentElementChildren(obj) {
    obj.children.map((c) => {
      if (c.id === this.state.element.id) {
        this.setState({ element: c });
      } else {
        this.updateCurrentElementChildren(c);
      }
    });
  }

  payloadItem(c) {
    let childrenObj = {};

    delete c.name;
    delete c.active;
    delete c.errors;
    if (typeof c.key.errors !== 'undefined') {
      delete c.key.errors;
    }
    if (typeof c.value.errors !== 'undefined') {
      delete c.value.errors;
    }

    if (c.children.length !== 0) {
      childrenObj = {
        children: c.children.map((_c) => {
          return this.payloadItem(_c);
        }),
      };
    }

    return Object.assign(c, childrenObj);
  }

  getPayload() {
    let children = JSON.parse(JSON.stringify(this.state.children));

    return children.map((c) => {
      return this.payloadItem(c);
    });
  }

  keyName() {
    if (this.state.property.template_name === '') {
      return 'undefined';
    }
    return this.state.property.template_name;
  }

  rootClassNames() {
    let classNames = [];

    if (this.state.visible === 'property') {
      classNames.push('active');
    }
    if (Object.keys(this.state.propertyErrors).length > 0) {
      classNames.push('hasError');
    }

    return classNames.join(' ');
  }

  renderOutput() {
    return (
      <div className='HashBuilderOutput'>
        <input
          readOnly
          name='property[property_type]'
          type='hidden'
          value='hash'
        />
        <input
          readOnly
          name='property[name]'
          type='hidden'
          value={this.state.property.name}
        />
        <input
          readOnly
          name='property[template_name]'
          type='hidden'
          value={this.state.property.template_name}
        />
        <input
          readOnly
          name='property[description]'
          type='hidden'
          value={this.state.property.description}
        />
        <input
          readOnly
          name='property[applies_to_node]'
          type='hidden'
          value={this.state.property.applies_to_node}
        />
        <input
          readOnly
          name='property[applies_to_server]'
          type='hidden'
          value={this.state.property.applies_to_server}
        />
        <input
          readOnly
          name='property[applies_to_node_group]'
          type='hidden'
          value={this.state.property.applies_to_node_group}
        />
        <input
          readOnly
          name='property[applies_to_customer]'
          type='hidden'
          value={this.state.property.applies_to_customer}
        />
        <input
          readOnly
          name='property[hash_definition]'
          type='hidden'
          value={JSON.stringify(this.getPayload())}
        />
      </div>
    );
  }

  render() {
    return (
      <div className='HashBuilderComponent'>
        {this.renderOutput()}
        <div className='TreeSection'>
          <div className='HashRootComponent'>
            <label>Name:</label>
            <a
              className={this.rootClassNames()}
              onClick={this.togglePropertyPanel.bind(this)}
            >
              {this.displayName()}
            </a>
          </div>
          <HashTree
            ref={this.treeRef}
            onChange={this.updateChildren.bind(this)}
            onClose={() => this.setState({ visible: false, element: false })}
            onOpen={(element) =>
              this.setState({ visible: 'element', element: element })
            }
          >
            {this.state.children}
          </HashTree>
        </div>
        <div className='HashPropertiesPanel'>
          <If condition={this.state.visible === 'property'}>
            <HashPropertyForm
              enabled={this.state.enabled}
              errors={this.state.propertyErrors}
              property={this.state.property}
              onChange={this.updateProperty.bind(this)}
            />
          </If>
          <If condition={this.state.visible === 'element'}>
            <HashElementForm
              element={this.state.element}
              enabled={this.state.enabled}
              types={this.props.types}
              onChange={this.updateElement.bind(this)}
            />
          </If>
        </div>
        <JsonPreview
          code={this.getPayload()}
          name={this.keyName()}
          open={this.state.openModal}
          renderedEntity={'hash'}
          title={`Property: ${this.state.property.name}`}
          onClose={() => this.setState({ openModal: false })}
        />
      </div>
    );
  }
}
